import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  setItemInLocalStorage(key, value): void {
    localStorage.setItem(key, value);
  }

  loadSessionData() {
    const sessionStr = JSON.parse(localStorage.getItem('admin'));
    if (sessionStr) {
      return sessionStr;
    }
    else {
      const sessionString = JSON.parse(localStorage.getItem('user'));
      return sessionString;
    }
  }
}
